export default {
  data () {
    return {
      adminUrl: 'http://wx.ahjunze.com/',
      loading: false,
      companyId: '',
      // 学校ID
      schollId: '',
      nowSelectClassName: '',
      //  学校列表
      schoolList: [],
      inputClass: '',
      productId: '',
      studentId: '',
      checkResult: [],
      // 年级列表
      gradeList: [
        { value: '', label: '全部年级' },
        { value: 1, label: '一年级' },
        { value: 2, label: '二年级' },
        { value: 3, label: '三年级' },
        { value: 4, label: '四年级' },
        { value: 5, label: '五年级' },
        { value: 6, label: '六年级' },

      ],
      // 学校选择框的数据
      selectValue: '0',
      // 年级选择框数据
      selectGrade: '全部年级',
      // 查询关键字
      classes: '',
      // 课程列表
      classList: [],
      radio: '1',
      total: 0,
      // 当前的页数
      page: 1,
      // 每页显示多少条
      pageSize: 10,
      rpage: 1,
      rtotal: 0,
      rpageSize: 10,
      payResult: [],
      resultDialogVisible: false,
      fileDialogVisible: false,
      fileUrl: '',
      productId: '',
      classesList: [],
      nowChoseClasses: '',
      stuName: null
    }
  },
  created () {
    this.companyId = window.sessionStorage.getItem('companyId')
    this.getOrganizationList()
  },
  methods: {
    // 获取机构列表
    async getOrganizationList () {
      const { data: res } = await this.$http.get('/admin/company', {
        params: {
          role: 3,
        }
      })
      if (res.code !== 200) return this.$message.error(res.msg)
      this.schoolList = res.companyList
      this.selectValue = res.companyList[0].companyName
      this.schoolId = res.companyList[0].id
      this.getClassList(res.companyList[0].id)
    },
    // 选择机构查询课程
    selectGetClassList () {
      this.page = 1
      this.schoolId = this.selectValue
      this.getClassList(this.selectValue)
    },
    // 根据ID查课程列表
    async getClassList (id) {
      this.loading = true
      const { data: res } = await this.$http.get('/admin/school/getSchoolCurriculum', {
        params: {
          schoolId: id,
          pageSize: this.pageSize,
          pageNum: this.page,
        }
      })
      if (res.code !== 200) return this.$message.error(res.msg)
      this.classList = res.curriculumList
      this.total = res.total
      this.loading = false
    },


    // 监听pagesize改变的事件
    handleSizeChange (newSize) {
      this.pageSize = newSize
      this.getClassList(this.schoolId)
    },
    //  监听页码的改变
    handleCurrentChange (newPage) {
      this.page = newPage
      this.getClassList(this.schoolId)
    },
    // 监听pagesize改变的事件
    handleCheckSizeChange (newSize) {
      this.rpageSize = newSize
      this.showResultDialog(this.productId)
    },
    //  监听页码的改变
    handleCheckCurrentChange (newPage) {
      this.rpage = newPage
      this.showResultDialog(this.productId)
    },
    // 展示课程报名结果的对话框
    async showResultDialog (id) {
      if (id !== '' && id !== 'c') {
        this.productId = id
        this.studentId = ''
        const { data: res } = await this.$http.get('/admin/school/getClasses', {
          params: {
            productId: id === '' ? this.productId : id,
          }
        })
        if (res.code !== 200) {
          return this.$message.error('获取失败，请稍后再试')
        }
        this.classesList = res.classes
      } else if (id === 'c') {
        this.studentId = ''
      }
      const { data: res } = await this.$http.get('/admin/school/getStuAttendance', {
        params: {
          productId: id === '' ? this.productId : id === 'c' ? this.productId : id,
          stuId: this.studentId,
          pageNum: this.rpage,
          pageSize: this.rpageSize,
          classes: this.nowChoseClasses === '' ? '' : parseInt(this.nowChoseClasses)
        }
      })
      if (res.code !== 200) {
        return this.$message.error('获取失败，请稍后再试')
      }
      this.checkResult = res.attendances
      this.rtotal = res.total
      this.resultDialogVisible = true
    },
    // 展示生成报名结果文件对话框
    async showFileDialog (id) {
      this.productId = id
      const { data: r } = await this.$http.get('/admin/school/getClasses', {
        params: {
          productId: id,
        }
      })
      if (r.code !== 200) {
        return this.$message.error('获取失败，请稍后再试')
      }
      r.classes.unshift('全部')
      this.classesList = r.classes
      const { data: res } = await this.$http.post('/admin/school/exportStuAttendance', {
        productId: id,
      })
      if (res.code !== 200) {
        return this.$message.error('获取失败，请稍后再试')
      }
      this.fileUrl = res.url
      this.fileDialogVisible = true
    },
    // 获取文件链接
    async getFile () {
      const { data: res } = await this.$http.post('/admin/school/exportStuAttendance', {
        productId: this.productId,
        classes: this.classes == '全部' ? null : parseInt(this.classes),
        stuName: this.stuName,
      })
      if (res.code !== 200) {
        return this.$message.error('获取失败，请稍后再试')
      }
      this.fileUrl = res.url
    },
  },



}
